module.exports = __webpack_public_path__ + "9baf67ffcc881cb53d12eb052d4d212b.mp4";